import { render, staticRenderFns } from "./scratchdownload.vue?vue&type=template&id=05591bc8&scoped=true&"
import script from "./scratchdownload.vue?vue&type=script&lang=js&"
export * from "./scratchdownload.vue?vue&type=script&lang=js&"
import style0 from "./scratchdownload.vue?vue&type=style&index=0&id=05591bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05591bc8",
  null
  
)

export default component.exports